var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

$(document).ready(function () {

    var screenWidth = screen.width;

    // $('.lp__hero--slide-wrapper').flickity({
    //     autoPlay: false,
    //     cellAlign: 'center',
    //     contain: true,
    //     draggable: '>1',
    //     dragThreshold: 8,
    //     freeScroll: false,
    //     initialIndex: 0,
    //     pageDots: false,
    //     selectedAttraction: 0.03,
    //     friction: 0.5,
    //     wrapAround: true,
    //     fade: true
    // });

    $('.content-carousel').flickity({
        autoPlay: 6000,
        cellAlign: 'left',
        contain: false,
        draggable: '>1',
        dragThreshold: 8,
        freeScroll: false,
        initialIndex: 0,
        pageDots: false,
        selectedAttraction: 0.03,
        friction: 0.5,
        wrapAround: true,
        on: {
            ready: () => {
              document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
                el.setAttribute('tabindex', '-1');
              })
            },
            select: () => { 
              document.querySelectorAll('.carousel-cell.is-selected a, .carousel-cell.is-selected button').forEach((el) => {
                el.removeAttribute('tabindex');
              })
        
              document.querySelectorAll('.carousel-cell[aria-hidden="true"] a, .carousel-cell[aria-hidden="true"] button').forEach((el) => {
                el.setAttribute('tabindex', '-1');
              })
            }
          }
    });

    function heroSlider() {
        $('.lp__hero--slide-wrapper').each( function() {
            $(this).slick( {
                touchThreshold: 30,
                mobileFirst: true,
                speed: 500,
                dots: false,
                fade: true,
                arrows: true,
                prevArrow: '<button type="button" class="slick-prev"></button>',
                nextArrow: '<button type="button" class="slick-next"></button>',
                autoplay: true,
                autoplaySpeed: 6000
            } );
        } );
    }
    heroSlider();

});
